export default __webpack_public_path__ + "static/dpc-81cba1f3b0d0da1d2fb846df606707ff.png";